import ProjectInitializationWorkflowStore from "./ProjectInitialization/ProjectInitializationWorkflowStore";
import DailyBatchLogWorkflowStore from "./DailyBatchLog/DailyBatchLogWorkflowStore";
import QCInspectionWorkflowStore from "./QCInspection/QCInspectionWorkflowStore";
import NCRWorkflowStore from "./NCR/NCRWorkflowStore";

// Estimating
import ProjectBidProposalWorkflowStore from "./Estimating/ProjectBidProposal/ProjectBidProposalWorkflowStore";

// Materials
import InventoryAdjustmentsWorkflowStore from "./InventoryAdjustments/InventoryAdjustmentsWorkflowStore";
import AddRawMaterialsWorkflowStore from "./AddRawMaterials/AddRawMaterialsWorkflowStore";
import PORequisitionWorkflowStore from "./PORequisition/PORequisitionWorkflowStore";

// Maintenance
import LaborTimeTrackingWorkflowStore from "./LaborTimeTracking/LaborTimeTrackingWorkflowStore";
import EquipmentMaintenanceWorkflowStore from "./EquipmentMaintenance/EquipmentMaintenanceWorkflowStore";

// Quality Control
import ToolCalibrationWorkflowStore from "./QualityControl/ToolCalibration/ToolCalibrationWorkflowStore";

// Dispatch & Fleet
import FleetDriverManagementWorkflowStore from "./FleetDriverManagement/FleetDriverManagementWorkflowStore";
import DeliveryConfirmationWorkflowStore from "./Dispatch/DeliveryConfirmation/DeliveryConfirmationWorkflowStore";

// Field Operations
import FieldIssueWorkflowStore from "./FieldOperations/FieldIssue/FieldIssueWorkflowStore";
import WarrantyClaimWorkflowStore from "./WarrantyClaim/WarrantyClaimWorkflowStore";
import SafetyComplianceWorkflowStore from "./FieldOperations/SafetyCompliance/SafetyComplianceWorkflowStore";

// Project Management
import ChangeOrderWorkflowStore from "./ChangeOrder/ChangeOrderWorkflowStore";
import ProjectBillingWorkflowStore from "./ProjectBilling/ProjectBillingWorkflowStore";
import CustomerCommunicationWorkflowStore from "./ProjectManagement/CustomerCommunication/CustomerCommunicationWorkflowStore";

// Analytics
import ReportBuilderWorkflowStore from "./Analytics/ReportBuilder/ReportBuilderWorkflowStore";

// ReadyMix-Specific Workflows
import BatchTicketGenerationWorkflowStore from "./BatchTicketGeneration/BatchTicketGenerationWorkflowStore";
import MixDesignApprovalWorkflowStore from "./MixDesignApproval/MixDesignApprovalWorkflowStore";
import TruckDispatchWorkflowStore from "./TruckDispatch/TruckDispatchWorkflowStore";
import DeliveryTicketGenerationWorkflowStore from "./DeliveryTicketGeneration/DeliveryTicketGenerationWorkflowStore";
import SlumpTestRecordingWorkflowStore from "./SlumpTestRecording/SlumpTestRecordingWorkflowStore";
import CylinderTrackingWorkflowStore from "./CylinderTracking/CylinderTrackingWorkflowStore";
import PlantInventoryCheckWorkflowStore from "./PlantInventoryCheck/PlantInventoryCheckWorkflowStore";
import MoistureCorrectionWorkflowStore from "./MoistureCorrection/MoistureCorrectionWorkflowStore";
import TruckMaintenanceWorkflowStore from "./TruckMaintenance/TruckMaintenanceWorkflowStore";
import CustomerDeliverySchedulingWorkflowStore from "./CustomerDeliveryScheduling/CustomerDeliverySchedulingWorkflowStore";

const workflowsStoreList = [
  // Core Workflows
  { name: "projectInitializationWorkflowStore", store: ProjectInitializationWorkflowStore },
  { name: "dailyBatchLogWorkflowStore", store: DailyBatchLogWorkflowStore }, // Renamed from DailyProductionLog
  { name: "qcInspectionWorkflowStore", store: QCInspectionWorkflowStore },
  { name: "ncrWorkflowStore", store: NCRWorkflowStore },

  // Estimating
  { name: "projectBidProposalWorkflowStore", store: ProjectBidProposalWorkflowStore },

  // Materials
  { name: "inventoryAdjustmentsWorkflowStore", store: InventoryAdjustmentsWorkflowStore },
  { name: "addRawMaterialsWorkflowStore", store: AddRawMaterialsWorkflowStore },
  { name: "poRequisitionWorkflowStore", store: PORequisitionWorkflowStore },

  // Maintenance
  { name: "laborTimeTrackingWorkflowStore", store: LaborTimeTrackingWorkflowStore },
  { name: "equipmentMaintenanceWorkflowStore", store: EquipmentMaintenanceWorkflowStore },

  // Quality Control
  { name: "toolCalibrationWorkflowStore", store: ToolCalibrationWorkflowStore },

  // Dispatch & Fleet
  { name: "fleetDriverManagementWorkflowStore", store: FleetDriverManagementWorkflowStore },
  { name: "deliveryConfirmationWorkflowStore", store: DeliveryConfirmationWorkflowStore },

  // Field Operations
  { name: "fieldIssueWorkflowStore", store: FieldIssueWorkflowStore },
  { name: "warrantyClaimWorkflowStore", store: WarrantyClaimWorkflowStore },
  { name: "safetyComplianceWorkflowStore", store: SafetyComplianceWorkflowStore },

  // Project Management
  { name: "changeOrderWorkflowStore", store: ChangeOrderWorkflowStore },
  { name: "projectBillingWorkflowStore", store: ProjectBillingWorkflowStore },
  { name: "customerCommunicationWorkflowStore", store: CustomerCommunicationWorkflowStore },

  // Analytics
  { name: "reportBuilderWorkflowStore", store: ReportBuilderWorkflowStore },

  // ReadyMix-Specific Workflows
  { name: "batchTicketGenerationWorkflowStore", store: BatchTicketGenerationWorkflowStore },
  { name: "mixDesignApprovalWorkflowStore", store: MixDesignApprovalWorkflowStore },
  { name: "truckDispatchWorkflowStore", store: TruckDispatchWorkflowStore },
  { name: "deliveryTicketGenerationWorkflowStore", store: DeliveryTicketGenerationWorkflowStore },
  { name: "slumpTestRecordingWorkflowStore", store: SlumpTestRecordingWorkflowStore },
  { name: "cylinderTrackingWorkflowStore", store: CylinderTrackingWorkflowStore },
  { name: "plantInventoryCheckWorkflowStore", store: PlantInventoryCheckWorkflowStore },
  { name: "moistureCorrectionWorkflowStore", store: MoistureCorrectionWorkflowStore },
  { name: "truckMaintenanceWorkflowStore", store: TruckMaintenanceWorkflowStore },
  { name: "customerDeliverySchedulingWorkflowStore", store: CustomerDeliverySchedulingWorkflowStore },
];

// Removed precast-specific workflow stores:
// - YardInventoryWorkflowStore
// - ShipmentPlanningWorkflowStore
// - EngineeringDataWorkflowStore
// - ProductionScheduleWorkflowStore
// - SubmittalPackageWorkflowStore
// - RFIManagementWorkflowStore
// - PieceRemediationWorkflowStore
// - LoadStagingWorkflowStore
// - YardAuditWorkflowStore
// - InstallationTrackingWorkflowStore

export default workflowsStoreList;
